import { range } from 'd3c';

// https://d3js.org/d3-tile/ Version 0.0.4. Copyright 2018 Mike Bostock.
export const d3TilesVector = () => {
  let x0 = 0,
      y0 = 0,
      x1 = 960, // container sizes
      y1 = 500,
      tx = (x0 + x1) / 2,
      ty = (y0 + y1) / 2,
      scale = 512,
      zoomDelta = 0,
      wrap = true;

  const tileSize = 709;

  function tile() {
    const z = Math.max(Math.log(scale) / Math.LN2 - Math.log2(tileSize), 0),
        z0 = Math.round(z + zoomDelta),
        j = 1 << z0,
        k = Math.pow(2, z - z0 + Math.log2(tileSize)),
        x = tx - scale / 2,
        y = ty - scale / 2,
        tiles = [],
        cols = range(
          Math.max(wrap ? -Infinity : 0, Math.floor((x0 - x) / k)),
          Math.min(Math.ceil((x1 - x) / k), wrap ? Infinity : j)
        ),
        rows = range(
          Math.max(0, Math.floor((y0 - y) / k)),
          Math.min(Math.ceil((y1 - y) / k), j)
        );

    rows.forEach(function(y) {
      cols.forEach(function(x) {
        tiles.push({
          x: (x % j + j) % j,
          y: y,
          z: z0,
          tx: x * tileSize,
          ty: y * tileSize
        });
      });
    });

    tiles.translate = [x / k, y / k];
    tiles.scale = k;
    return tiles;
  }

  tile.size = function(_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], tile) : [x1 - x0, y1 - y0];
  };

  tile.extent = function(_) {
    return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], tile) : [[x0, y0], [x1, y1]];
  };

  tile.scale = function(_) {
    return arguments.length ? (scale = +_, tile) : scale;
  };

  tile.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], tile) : [tx, ty];
  };

  tile.zoomDelta = function(_) {
    return arguments.length ? (zoomDelta = +_, tile) : zoomDelta;
  };

  tile.wrap = function(_) {
    return arguments.length ? (wrap = _, tile) : wrap;
  };

  return tile;
};
